module.exports = __webpack_public_path__ + "img/our-work-04.8f768771.jpg";